import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/home-data';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex flex-col items-center justify-start pt-32 md:pt-40 pb-16 md:pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20atmospheric%20scene%20with%20deep%20shadows%20and%20warm%20amber%20glow%2C%20abstract%20textured%20background%20with%20mysterious%20mood%2C%20editorial%20photography%20style%2C%20dark%20brown%20and%20warm%20golden%20highlights%2C%20no%20text%2C%20no%20people%2C%20subtle%20gradient%20from%20dark%20to%20warm%20light&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜官网首页背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80" />

      <div className="relative z-10 w-full text-center px-4">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse" />
          <span className="text-primary-300 text-xs font-medium tracking-wider">实时更新中 · 今日已更新 23 条爆料</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight tracking-wide max-w-3xl mx-auto">
          今日大瓜
          <br />
          独家爆料
          <br />
          实时更新
        </h1>

        <p className="mt-6 text-base md:text-lg text-background-50/60 max-w-xl mx-auto leading-relaxed">
          吃瓜官网 — 51吃瓜在线第一入口，汇聚全网最新最全的黑料吃瓜与网红翻车现场
        </p>

        <Link
          to="/category/hot"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap group"
        >
          立即吃瓜
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto mt-14 md:mt-20 px-4">
        <div className="flex items-end justify-center gap-0 md:gap-2 lg:gap-4">
          {featuredArticles.map((article, index) => {
            const isCenter = index === 1;
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className={`relative block rounded-xl overflow-hidden bg-background-50 cursor-pointer group transition-all duration-300 hover:-translate-y-1 ${
                  isCenter
                    ? 'w-[38%] md:w-[36%] z-20 -mx-1 md:-mx-2'
                    : 'w-[28%] md:w-[28%] z-10 opacity-90 hover:opacity-100'
                }`}
                style={{
                  transform: isCenter
                    ? 'translateY(0) scale(1.06)'
                    : index === 0
                    ? 'translateY(12px) rotate(-1deg)'
                    : 'translateY(12px) rotate(1deg)',
                }}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                {isCenter && (
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-[10px] font-semibold rounded-full whitespace-nowrap">
                      {article.isNew ? '最新爆料' : '今日大瓜'}
                    </span>
                  </div>
                )}
                <div className="p-3 md:p-4">
                  <h3 className="font-heading text-xs md:text-sm font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-2 text-[10px] md:text-xs text-foreground-400">
                    <span>{article.categoryName}</span>
                    <span>·</span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}